export const dashboardLayoutTypeContext = 2;

export const DashboardComponentSavedReports = 'savedReports';
